import { alertAggregationSettingsResponseSchema, updateAlertAggregationSettingsBodySchema, } from '../contracts/alert-aggregation';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Get personal in-app alert aggregation settings for the current user.
 *
 * When no setting exists, the backend returns the Balanced default.
 */
export async function getUserAlertAggregationSettings(client) {
    const response = await client.get('/account/settings/alert-aggregation');
    return parseSchema(alertAggregationSettingsResponseSchema, response);
}
/**
 * Update personal in-app alert aggregation settings for the current user.
 */
export async function updateUserAlertAggregationSettings(client, body) {
    const validatedBody = parseSchema(updateAlertAggregationSettingsBodySchema, body);
    const response = await client.put('/account/settings/alert-aggregation', validatedBody);
    return parseSchema(alertAggregationSettingsResponseSchema, response);
}
/**
 * Get organization in-app alert aggregation settings.
 *
 * Authorization: Owner, Manager, or Member (all can view).
 * When no setting exists, the backend returns the Balanced default.
 */
export async function getOrgAlertAggregationSettings(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/settings/alert-aggregation`);
    return parseSchema(alertAggregationSettingsResponseSchema, response);
}
/**
 * Update organization in-app alert aggregation settings.
 *
 * Authorization: Owner or Manager only (members cannot modify).
 */
export async function updateOrgAlertAggregationSettings(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(updateAlertAggregationSettingsBodySchema, body);
    const response = await client.put(`/organizations/${validatedId}/settings/alert-aggregation`, validatedBody);
    return parseSchema(alertAggregationSettingsResponseSchema, response);
}
//# sourceMappingURL=alert-aggregation.js.map